import { render } from "./CabinetPage.vue?vue&type=template&id=74cce87b"
import script from "./CabinetPage.vue?vue&type=script&lang=js"
export * from "./CabinetPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__